import React, { useState } from "react";
import useCredit from "../../hooks/useCredit";
import { Loading } from "../../components/Loading";
import { Header } from "../../components/Header";
import { Table } from "antd";
import { IncreaseCreditModal } from "./IncreaseCreditModal/IncreaseCreditModal";
import { ContentCard } from "../../components/ContentCard/ContentCard";
import FilterCreditManagement from "./FilterCreditManagement/FilterCreditManagement";

import { addTomanPriceComma } from "../../core/utils";

export const CreditManagement = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { Column } = Table;
  const {
    users,
    setUsers,
    provinces,
    cities,
    setCities,
    onChangeAmount,
    increaseCredit,
    loading,
    creditsData,
    getCredits,
    form,
    search,
    setSearch,
    increaseCreditState,
    handleChangeIncreaseCreditState,
    changePage,
    getUsers,
    exportCredits,
  } = useCredit({ setIsModalOpen });

  return (
    <>
      <Header
        title="Credit Management"
        activeItem="CreditManagement"
        leftTitle={
          <div>
            {/* <span>
              Total Credit:{" "}
              {creditsData?.extra?.company_credit &&
                addTomanPriceComma(creditsData?.extra?.company_credit)}{" "}
              USD
            </span>
            <span></span> */}
            <span>Total Credit: {addTomanPriceComma(3000000)} USD</span>
          </div>
        }
      />

      <ContentCard
        filter={
          <FilterCreditManagement
            getCredits={getCredits}
            provinces={provinces}
            cities={cities}
            setCities={setCities}
            users={users}
            form={form}
            search={search}
            setSearch={setSearch}
            getUsers={getUsers}
            exportCredits={exportCredits}
          />
        }
        add={
          <IncreaseCreditModal
            isModalOpen={isModalOpen}
            setIsModalOpen={setIsModalOpen}
            users={users}
            setUsers={setUsers}
            onChangeAmount={onChangeAmount}
            increaseCredit={increaseCredit}
            increaseCreditState={increaseCreditState}
            handleChangeIncreaseCreditState={handleChangeIncreaseCreditState}
            cities={cities}
            setCities={setCities}
            provinces={provinces}
            getUsers={getUsers}
          />
        }
      >
        <Loading isLoading={loading}>
          <Table
            size="small"
            scroll={{ x: 640 }}
            dataSource={creditsData || []}
            pagination={{
              position: ["bottomCenter"],
              current: creditsData?.pagination?.page,
              pageSize: creditsData?.pagination?.limit,
              total: creditsData?.pagination?.count,
              onChange: changePage,
            }}
          >
            <Column
              title="Name"
              dataIndex="user"
              render={(user) => <>{user.fullname}</>}
            />
            <Column
              title="City"
              dataIndex="city"
              key="city"
              render={(city) => (
                <>
                  <small className="color-promotion-s1 mr-10 ml-5">
                    [{city.map((ckey) => ckey.province).join(", ")}]
                  </small>
                  <span className="mx-10">
                    {city.map((ckey) => ckey.city).join(", ")}
                  </span>
                </>
              )}
            />
            <Column
              title="Charged Credit"
              dataIndex="amount"
              render={(amount) => (
                <span className={`${amount > 0 ? "color-primary" : ""}`}>
                  {amount > 0 ? <>{addTomanPriceComma(amount)} USD</> : 0}
                </span>
              )}
            />
            {/* <Column
              title="Decreased Credit"
              dataIndex="amount"
              render={(amount) => (
                <span className={`${amount < 0 ? "color-red" : ""}`}>
                  {amount < 0 ? (
                    <>{addTomanPriceComma(Math.abs(amount))} USD</>
                  ) : (
                    0
                  )}
                </span>
              )}
            /> */}
            <Column
              title="Registration Date"
              dataIndex="created_at"
              render={(created_at) => <>{created_at}</>}
            />
            <Column
              title="Remaining Credit"
              dataIndex="current_total_amount"
              render={(current_total_amount) => (
                <>{addTomanPriceComma(current_total_amount)} USD</>
              )}
            />
          </Table>
        </Loading>
      </ContentCard>
    </>
  );
};
